import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { matchFilterNumber, sortArrayBy } from '@domain-group/javascript-utils'

import { useWatchEntityUpdates } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

const watchEntityKeys = ['providerDeadlineGroups']

function useProviderDeadlineGroups(options = {}){
  const { entityKey, filters, performHttpRequests } = options
  const { provider_id: filterProviderId } = filters || {}

  const {
    updatedEntities: { providerDeadlineGroups: providerDeadlineGroupsUpdatedAt },
  } = useWatchEntityUpdates(watchEntityKeys)

  const { loading: loadingProviderDeadlineGroups } = useReduxAction(
    'providerDeadlineGroups',
    'loadProviderDeadlineGroups',
    {
      entityKey,
      ...filters,
    },
    [performHttpRequests, filters],
    {
      shouldPerformFn: ({ loading }) => performHttpRequests && !loading,
    },
  )

  const { providerDeadlineGroups } = useSelector(reduxState => reduxState.entities)

  const filteredProviderDeadlineGroups = useMemo(() => {
    const filtered = Object.values(providerDeadlineGroups).filter((providerDeadlineGroup) => {
      const { provider_id } = providerDeadlineGroup

      const matchProviderId = filterProviderId ? matchFilterNumber(provider_id, filterProviderId) : false

      return matchProviderId
    })

    return sortArrayBy(filtered, 'asc', 'title')
  }, [providerDeadlineGroupsUpdatedAt, JSON.stringify(filters)])

  const hasFilteredProviderDeadlineGroups = !!filteredProviderDeadlineGroups.length

  return {
    filteredProviderDeadlineGroups,
    hasFilteredProviderDeadlineGroups,
    loading: loadingProviderDeadlineGroups,
  }
}

export default useProviderDeadlineGroups
